module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Light.b4bc0977.ttf";